import React, { Component } from 'react';

import { compose } from 'redux';

import { loadMoreNotifications, reloadNotifications } from 'common/actions/notifications';
import AJAX from 'common/AJAX';
import { CompanyContext } from 'common/containers/CompanyContainer';
import ContentContainer from 'common/containers/ContentContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import connect from 'common/core/connect';
import Helmet from 'common/helmets/Helmet';
import NotificationList from 'common/notifications/NotificationList';
import Tappable from 'common/Tappable';
import withContexts from 'common/util/withContexts';

import type { Company } from 'common/api/endpoints/companies';
import type { Viewer } from 'common/api/endpoints/viewer';
import type { NotificationsState } from 'common/reducers/notifications';

import 'css/components/subdomain/public/_SubdomainNotifications.scss';

type Props = {
  company: Company;
  notifications: NotificationsState;
  viewer: Viewer;
  loadMoreNotifications: () => void;
  reloadNotifications: () => void;
};

class SubdomainNotifications extends Component<Props> {
  componentDidMount() {
    const { viewer } = this.props;
    if (!viewer || !viewer._id) {
      return;
    }

    AJAX.post('/api/notifications/markAllSeen', {});
  }

  markAllAsRead = async () => {
    const response = await AJAX.post('/api/notifications/markAllRead', {});

    if (response === 'success') {
      this.props.reloadNotifications();
    }
  };

  renderMarkAllLink() {
    return (
      <Tappable onTap={this.markAllAsRead}>
        <div className="markAll">Mark all as read</div>
      </Tappable>
    );
  }

  renderContents() {
    const { viewer } = this.props;
    if (!viewer || !viewer._id) {
      return <div className="loggedOut">You are not logged in.</div>;
    }

    return (
      <>
        <div className="notificationHeader">
          <div className="heading">Notifications</div>
          {this.renderMarkAllLink()}
        </div>
        <NotificationList
          notifications={this.props.notifications}
          onLoadMoreTapped={() => {
            this.props.loadMoreNotifications();
          }}
        />
      </>
    );
  }

  render() {
    return (
      <div className="subdomainNotifications">
        <ContentContainer>
          <Helmet title={`Notifications | ${this.props.company.name}`} />
          {this.renderContents()}
        </ContentContainer>
      </div>
    );
  }
}

export default compose(
  connect(null, { loadMoreNotifications, reloadNotifications }),
  withContexts(
    {
      company: CompanyContext,
      viewer: ViewerContext,
    },
    {
      forwardRef: true,
    },
  ),
)(SubdomainNotifications) as unknown as React.ComponentType<Props>;
